"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    map: {
        en: "Map",
        es: "Mapa",
    },
    user: {
        en: "User",
        es: "Usuario",
    },
    maintenance: {
        en: "Maintenance",
        es: "Mantenimiento",
    },
    devices: {
        en: "Units",
        es: "Unidades",
    },
    network: {
        en: "Network",
        es: "Red",
    },
    digitalInput: {
        en: "Digital Inputs",
        es: "Entradas Digitales",
    },
    listOfDigitalInputs: {
        en: "List of Digitals Inputs",
        es: "Lista de Entradas Digitales",
    },
    address: {
        en: "Address",
        es: "Dirección",
    },
    simDataUsage: {
        en: "Data Usage",
        es: "Uso de Datos",
    },
    dataUsageAlert: {
        en: "Data Usage Alert",
        es: "Alerta de consumo de datos",
    },
    dataUsageWarning: {
        en: "Device: {description} has reach more than 90% of data usage, its remainding {percentage}",
        es: "Unidad: {description} ha alcanzado mas del 90% de datos, solo resta {percentage}",
    },
    dateRangeLimit: {
        en: "The dates range cannot exceed {days} days",
        es: "El rango de fechas no puede exceder {days} días",
    },
    speed: {
        en: "Speed",
        es: "Velocidad",
    },
    speedatRPM: {
        en: "{speed} at {rpm}",
        es: "{speed} a {rpm}",
    },
    temperature: {
        en: "Temperature",
        es: "Temperatura",
    },
    or: {
        en: "Or",
        es: "O",
    },
    found: {
        en: "Found",
        es: "Encontrado",
    },
    notFound: {
        en: "Not Found",
        es: "No se Encontró",
    },
    camera: {
        en: "Camera",
        es: "Cámara",
    },
    videoCamera: {
        en: "Video camera",
        es: "Cámara de video",
    },
    comment: {
        en: "Comment",
        es: "Comentario",
    },
    table: {
        en: "Table",
        es: "Tabla",
    },
    infoNotAvailable: {
        en: "Information not available",
        es: "Información no disponible",
    },
    list: {
        en: "List",
        es: "Lista",
    },
    timeLine: {
        en: "Time Line",
        es: "Linea Cronológica",
    },
    tableTotalSession: {
        en: "Total of {name, plural, =0 {no Sessions} one {# Session}other {# Sessions}}.",
        es: "Total de {name, plural, =0 {No tiene} one {# Sesión}other {# Sesiones}}.",
    },
    deleteZero: {
        en: "You didn't select any row.",
        es: "No se selecciono ninguna fila.",
    },
    unitStatus: {
        en: "Current State",
        es: "Estado Actual",
    },
    sukarneTrips: {
        en: "Sukarne trips",
        es: "Viajes Sukarne",
    },
    startsAt: {
        en: "Starts at",
        es: "Empieza el",
    },
    endsAt: {
        en: "Ends at",
        es: "Finaliza el",
    },
    pending: {
        en: "Pending",
        es: "Pendiente",
    },
    inProgress: {
        en: "In progress",
        es: "En curso",
    },
    completed: {
        en: "Completed",
        es: "Finalizado",
    },
    inCompleted: {
        en: "Incompleted",
        es: "Sin Finalizar",
    },
    trip: {
        en: "Trip",
        es: "Viaje",
    },
    origin: {
        en: "Origin",
        es: "Origen",
    },
    destination: {
        en: "Destination",
        es: "Destino",
    },
    eventsTimeline: {
        en: "Events Timeline",
        es: "Cronología de Eventos",
    },
    geofenceTimeline: {
        en: "Geofence timeline",
        es: "Cronología de geocerca",
    },
    eventDetails: {
        en: "Events Detail",
        es: "Eventos Detalle",
    },
    eventGeofence: {
        en: "Geofence Events",
        es: "Geocerca Eventos",
    },
    unitStatusDetail: {
        en: "Current State Detail",
        es: "Estado Actual Detalle",
    },
    preventiveMaintenance: {
        en: "Scheduled Maintenance",
        es: "Mantenimiento Preventivo",
    },
    speedTop5: {
        en: "Speed Top 5",
        es: "Velocidad Max 5",
    },
    batteryLevel: {
        en: "Battery Level",
        es: "Batería",
    },
    editDashboard: {
        en: "Edit Dashboard",
        es: "Editar Tablero",
    },
    noChartData: {
        en: "No data",
        es: "No hay datos",
    },
    continue: {
        en: "Continue",
        es: "Continuar",
    },
    yes: {
        en: "Yes",
        es: "Si",
    },
    yesConfirm: {
        en: "Yes",
        es: "Sí",
    },
    no: {
        en: "No",
        es: "No",
    },
    add: {
        en: "Add",
        es: "Agregar",
    },
    allEvents: {
        en: "All Events",
        es: "Todos los Eventos",
    },
    previewLoadError: {
        en: "Could not load file preview.",
        es: "No se pudo cargar la vista previa del archivo.",
    },
    maxFilesSelectedError: {
        en: "Exceeded file quantity (max: {quantity})",
        es: "Cantidad de archivos excedida (máximo: {quantity})",
    },
    dragAdd: {
        en: "Click here or drag files to this area to upload",
        es: "Haga clic aquí o arrastre archivos a esta área para subir",
    },
    LOGIN_SUCCESS: {
        en: "{name} logged in.",
        es: "{name} inició sesión.",
    },
    LOGIN_FAILED: {
        en: "{name} failed to log in.",
        es: "{name} tuvo un error al iniciar sesión.",
    },
    LOGOUT_SUCCESS: {
        en: "{name} logged out.",
        es: "{name} se desconectó.",
    },
    LOGOUT_FAILED: {
        en: "{name} failed to log out.",
        es: "{name} tuvo un error al desconectarse.",
    },
    IMPERSONATE_SUCCESS: {
        en: "{impersonator} impersonated {impersonated}.",
        es: "{impersonator} impersonó a {impersonated}.",
    },
    IMPERSONATE_FAILED: {
        en: "{impersonator} failed to impersonate {impersonated}.",
        es: "{impersonator} tuvo un error al intentar impersonar a {impersonated}.",
    },
    REVERT_IMPERSONATE_SUCCESS: {
        en: "{impersonator} reverted impersonate from {impersonated}.",
        es: "{impersonator} revirtió impersonar a {impersonated}.",
    },
    REVERT_IMPERSONATE_FAILED: {
        en: "{impersonator} failed to revert impersonate from {impersonated}.",
        es: "{impersonator} tuvo un error al intentar revertir impersonar a {impersonated}.",
    },
    temperatureEvent: {
        en: "Temperature Sensor",
        es: "Sensor de Temperatura",
    },
    temperatureThermometerConfig: {
        en: "Thermometers configuration ",
        es: "Configuración de termómetros",
    },
    fuelSensors: {
        en: "Fuel Sensors",
        es: "Sensor de Combustible",
    },
    configuration: {
        en: "Configuration",
        es: "Configuración",
    },
    configurations: {
        en: "Configurations",
        es: "Configuraciones",
    },
    idle: {
        en: "Idle",
        es: "Estacionado con motor encendido",
    },
    parameters: {
        en: "Parameters",
        es: "Parámetros",
    },
    report: {
        en: "Report",
        es: "Reporte",
    },
    every: {
        en: "Every",
        es: "Cada",
    },
    month: {
        en: "Month",
        es: "Mes",
    },
    week: {
        en: "Week",
        es: "Semana",
    },
    day: {
        en: "Day",
        es: "Día",
    },
    months: {
        en: "Months",
        es: "Meses",
    },
    weeks: {
        en: "Weeks",
        es: "Semanas",
    },
    days: {
        en: "Days",
        es: "Días",
    },
    dataUsed: {
        en: "Data Used",
        es: "Datos Utilizados",
    },
    dataLimit: {
        en: "Data Limit",
        es: "Límite de datos",
    },
    billingCycleRemainingDays: {
        en: " to reset monthly data package.",
        es: " para reinicio de paquete de datos mensual.",
    },
    billingcycle: {
        en: "Billing cycle",
        es: "Ciclo de facturación",
    },
    traceSegmentation: {
        en: "Trace segmentation",
        es: "Segmentación de rastro",
    },
    thermometer: {
        en: "Thermometer",
        es: "Termómetro",
    },
    updatedOn: {
        en: "Updated on",
        es: "Actualizado el ",
    },
    notProcessed: {
        en: "Not processed",
        es: "Sin procesar",
    },
    onQueue: {
        en: "On queue",
        es: "En cola",
    },
    generated: {
        en: "Generated",
        es: "Generado",
    },
    home: {
        en: "Home",
        es: "Inicio",
    },
    fail: {
        en: "Fail",
        es: "Falló",
    },
    createdOn: {
        en: "Created on",
        es: "Creado en ",
    },
    recurrence: {
        en: "Recurrence",
        es: "Recurrencia",
    },
    sendTo: {
        en: "Send to",
        es: "Enviar a",
    },
    batteryVoltage: {
        en: "Battery voltage",
        es: "Voltage de batería",
    },
    remindOfMaintenance: {
        en: "Remind of maintenance",
        es: "Recordatorio de mantenimiento",
    },
    accumulatedHours: {
        en: "Accumulated hours",
        es: "Horas acumuladas",
    },
    distanceDriven: {
        en: "Distance driven",
        es: "Distancia conducida",
    },
    startCountOn: {
        en: "Start count since",
        es: "Contar desde",
    },
    restartCountOn: {
        en: "Restart count since",
        es: "Reiniciar conteo desde",
    },
    shipmentConfiguration: {
        en: "Shipment configuration",
        es: "Configuración de envió",
    },
    expectedEfficiency: {
        en: "Expected efficiency",
        es: "Eficiencia esperada",
    },
    nextShipment: {
        en: "Next Shipment",
        es: "Próximo envío",
    },
    gallons: {
        en: "Gallons",
        es: "Galones",
    },
    liters: {
        en: "Liters",
        es: "Litros",
    },
    reading: {
        en: "Reading",
        es: "Lectura",
    },
    interpolation: {
        en: "Interpolation",
        es: "Interpolación",
    },
    reportType: {
        en: "Report type",
        es: "Tipo de reporte",
    },
    accountAlert: {
        en: "Event by user",
        es: "Evento por usuario",
    },
    hourly: {
        en: "Hourly",
        es: "Hourly",
    },
    daily: {
        en: "Daily",
        es: "Diario",
    },
    line: {
        en: "Line",
        es: "Linea",
    },
    point: {
        en: "Point",
        es: "Punto",
    },
    weekly: {
        en: "Weekly",
        es: "Semanal",
    },
    biWeekly: {
        en: "Biweekly",
        es: "Quincenal",
    },
    monthly: {
        en: "Monthly",
        es: "Mensual",
    },
    options: {
        en: "Options",
        es: "Opciones",
    },
    limit: {
        en: "Limit",
        es: "Limite",
    },
    retry: {
        en: "Retry",
        es: "Reintentar",
    },
    liveCamera: {
        en: "LIVE",
        es: "EN VIVO",
    },
    rectangular: {
        en: "Rectangular",
        es: "Rectangular",
    },
    irregular: {
        en: "Irregular",
        es: "Irregular",
    },
    percentage: {
        en: "Percentage",
        es: "Porcentaje",
    },
    cylindrical: {
        en: "Cylindrical",
        es: "Cilindrico",
    },
    bill: {
        en: "Bill",
        es: "Factura",
    },
    createdBy: {
        en: "Created by",
        es: "Creado por",
    },
    dateRequested: {
        en: "Invoice date",
        es: "Fecha de la factura",
    },
    maintenanceUnitsDescription: {
        en: 'Units added to this form will be tracked for scheduled maintenance',
        es: 'Las unidades añadidas a este formulario serán rastreadas para el mantenimiento programado.'
    },
    deleteUnit: {
        en: 'Delete Unit',
        es: 'Eliminar Unidad'
    },
    addUnit: {
        en: 'Add Unit',
        es: 'Agregar Unidad'
    },
    gasStations: {
        en: "Gas Stations",
        es: "Gasolineras",
    },
    requesters: {
        en: "Requesters",
        es: "Solicitantes",
    },
    devicesByCompany: {
        en: "Devices by Company",
        es: "Unidades por Compañía",
    },
    commandForCustomerSupport: {
        en: "Command for customer support",
        es: "Comando para servicio al cliente",
    },
    customCommand: {
        en: "Custom Command",
        es: "Commando Personalizado",
    },
    commandQueued: {
        en: "Command queued",
        es: "Comando encolado",
    },
    direct: {
        en: "Direct",
        es: "Directo",
    },
    queued: {
        en: "Queued",
        es: "En cola",
    },
    request: {
        en: "Request",
        es: "Solicitud",
    },
    response: {
        en: "Response",
        es: "Respuesta",
    },
    responseSatuts: {
        en: "Response Status",
        es: "Estado de Respuesta",
    },
    credentials: {
        en: "Credentials",
        es: "Credenciales",
    },
    viewData: {
        en: "View Data",
        es: "Ver Datos",
    },
    photo: {
        en: "Photo",
        es: "Foto",
    },
    video: {
        en: "Video",
        es: "Video",
    },
    initialDate: {
        en: "Initial date",
        es: "Fecha inicial",
    },
    endingDate: {
        en: "End Date",
        es: "Fecha Final",
    },
    automaticCommand: {
        en: "Automatic Commands",
        es: "Comandos Automáticos",
    },
    manageDevices: {
        en: "Manage Units",
        es: "Administrar Unidades",
    },
    scheduler: {
        en: "Scheduler.",
        es: "Planificador.",
    },
    unSubscribeFromAlerts: {
        en: "You want to stop receiving alerts in your email?",
        es: "¿Desea dejar de recibir alertas en su correo electrónico?",
    },
    kilometers: {
        en: "Kilometers",
        es: "Kilómetros",
    },
    miles: {
        en: "Miles",
        es: "Millas",
    },
    taskScheduler: {
        en: "Tasks Planner",
        es: "Planificador de tareas",
    },
    efficiencyMessage: {
        en: "You will be notified when the efficiency is less than",
        es: "Se alertará cuando la eficiencia sea menor a",
    },
    irregularConsumptionMessage: {
        en: "You will be notify when the fuel consumption exceeds ",
        es: "Se alertará cuando el nivel de combustible consumido sea mayor a",
    },
    fillingMessage: {
        en: "You will be notify when the fuel fill-up exceeds ",
        es: "Se alertará cuando el nivel de combustible ingresado sea mayor a",
    },
    todo: {
        en: "Assigned",
        es: "Asignadas",
    },
    skippedTask: {
        en: "Skipped",
        es: "Omitida",
    },
    filter: {
        en: "Filter",
        es: "Filtro",
    },
    effective: {
        en: "Effective",
        es: "Efectivo",
    },
    manageSubscriptions: {
        en: "Manage Subscriptions",
        es: "Administrar Suscripciones",
    },
    select: {
        en: "Select",
        es: "Seleccionar",
    },
    calendar: {
        en: "Calendar",
        es: "Calendario",
    },
    retransmissions: {
        en: "Retransmissions",
        es: "Retransmisiones",
    },
    retransmission: {
        en: "Retransmission",
        es: "Retransmisión",
    },
    completedOn: {
        en: "Completed on",
        es: "Completado en",
    },
    totalRetransmissionTasks: {
        en: "Total tasks",
        es: "Tareas totales",
    },
    viewTasks: {
        en: "View tasks",
        es: "Ver las tareas",
    },
    processedOn: {
        en: "Processed on",
        es: "Procesado en",
    },
    failed: {
        en: "Failed",
        es: "Fallido",
    },
    fromTo: {
        en: "From - To",
        es: "Desde - Hasta",
    },
    timeRange: {
        en: "Time range",
        es: "Rango de tiempo",
    },
    addRetransmission: {
        en: "Add retransmission",
        es: "Agregar retransmisión",
    },
    retransmissionCreated: {
        en: "Retransmission created successfully",
        es: "Retransmisión creada exitosamente",
    },
    existIncompletedRetransmissions: {
        en: "There are incomplete retransmissions",
        es: "Existen retransmissiones incompletas",
    },
    openInNewTab: {
        en: "Open in new tab",
        es: "Abrir en pestaña nueva",
    },
    deviceUploadTitle: {
        en: "Upload Devices Completed",
        es: "Carga de Dispositivos Completada",
    },
    deviceUploadFailedTitle: {
        en: "Upload Devices Failed",
        es: "Carga de Dispositivos Fallida",
    },
    deviceUploadCompleted: {
        en: "The devices have been processed successfully. You can now review or edit them in the Unit section.",
        es: "Las unidades se han procesado exitosamente. Ahora puedes revisarlos o editarlos desde la seccion de Unidades.",
    },
    deviceUploadFailed: {
        en: "There was an error processing the devices. Please contact customer support for more information.",
        es: "Hubo un erro al momento de procesar los dispositivos. Por favor contacte con soporte tecnico para mas informacion.",
    },
    confirmationLeave: {
        en: "Leave without saving?",
        es: "¿Salir sin guardar?",
    },
    changeType: {
        en: "Change Maintenance Type?",
        es: "¿Cambiar tipo de mantenimiento?"
    },
    changeTypeDescription: {
        en: 'Changing the maintenance type will remove all added units. Are you sure you want to continue?',
        es: 'Al cambiar el tipo de mantenimiento, se eliminarán todas las unidades agregadas. ¿Estás seguro de que deseas continuar?'
    },
    confirmationLeaveDescription: {
        en: "You have made some changes to the form, are you sure you want to leave?",
        es: "Ha realizado cambios en el formulario, ¿Está seguro que desea salir?",
    },
    diagnostics: {
        en: "Diagnostics",
        es: "Diagnósticos",
    },
    platform: {
        en: "Platform",
        es: "Plataforma",
    },
    migrated: {
        en: "Migrated",
        es: "Migrado",
    },
    toolbarSelectAll: {
        en: "Select all {total} {context}",
        es: "Seleccionar todas las {total} {context}",
    },
    toolbarAllSelected: {
        en: "All {quantity} {context} from the table are selected.",
        es: "Todas las {quantity} {context} de la tabla fueron seleccionadas.",
    },
    toolbarSelected: {
        en: "All {selected} {context} on this page are selected.",
        es: "Todas las {selected} {context} en esta página fueron seleccionadas",
    },
    emptyMaintenanceInfo: {
        en: "Add a maintenance task to track when your device needs the next maintenance and receive timely reminders when it happens.",
        es: "Agrega una tarea de mantenimiento para llevar un registro cu\u00E1ndo tu dispositivo necesite el pr\u00F3ximo mantenimiento y recibir notificaciones cuando suceda."
    },
};
exports.default = translations;
